import { actions, WATCHLISTS_STORE_NAME, WatchlistsStore } from './store';
import { frontendActions, LocationType } from '@cmctechnology/webinvest-store-frontend';
import { CmcWebApi, IWebApiRequestBody } from '@cmctechnology/webinvest-api-client-web-trading';
import { Dispatch } from '@reduxjs/toolkit';
import { WATCHLIST_API_NAMES } from './apiNames';

type GetState = typeof WatchlistsStore.getState;

export const fetchOptoWatchlists = (location: LocationType, refresh: boolean = false) => {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    const hash = refresh ? 0 : getState()[WATCHLISTS_STORE_NAME].optoWatchlistsHash;
    const request: IWebApiRequestBody = {
      _config: { hash },
      Group: 'Opto'
    };

    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Watchlists.ThematicWatchlistsResponseModel1>(
        WATCHLISTS_STORE_NAME,
        WATCHLIST_API_NAMES.ThematicWatchlistsGet1,
        request,
        dispatch,
        location,
        refresh,
        true
      );
      dispatch(actions.optoWatchlistsFetched({ response, listsHash: response._apiInfo?.Hash ?? 0 }));
    } catch {}
  };
};

export const fetchOptoWatchlist = (id: number, key: string, refresh: boolean = false) => {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    const item = getState()[WATCHLISTS_STORE_NAME].optoItems?.[id];
    const hash = refresh ? 0 : (item?.hash ?? 0);
    const request: CmcWebApi.Watchlists.ThematicWatchlistRequest1 & IWebApiRequestBody = {
      Id: id as number,
      _config: { hash }
    };

    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Watchlists.ThematicWatchlistDetailResponseModel1>(
        WATCHLISTS_STORE_NAME,
        WATCHLIST_API_NAMES.ThematicWatchlistGet1,
        request,
        dispatch,
        key,
        refresh,
        true
      );
      dispatch(actions.optoWatchlistFetched({ id: id as number, response, hash: response._apiInfo?.Hash ?? 0 }));
    } catch {}
  };
};
